/** @format */

import { Button } from "@ui-library/core"
import styled, { css } from "styled-components"

export interface ISkeletonLoaderProps {
	isLoading?: boolean
}

const skeletonLoader = css`
	background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);
	border-radius: 5px;
	background-size: 200% 100%;
	animation: 1.5s shine linear infinite;
	* {
		opacity: 0;
	}
	color: transparent !important;

	:disabled{
		background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);
		background-size: 200% 100%;
	}
`

export const SkeletonLoaderDiv = styled.div<ISkeletonLoaderProps>`
	${props => (props.isLoading ? skeletonLoader : ";")}
`
export const SkeletonLoaderTitle = styled.h1<ISkeletonLoaderProps>`
	${props => (props.isLoading ? skeletonLoader : ";")}
`
export const SkeletonLoaderText = styled.p<ISkeletonLoaderProps>`
	${props => (props.isLoading ? skeletonLoader : ";")}
`
export const SkeletonLoaderButton = styled(Button)<ISkeletonLoaderProps>`
	${props => (props.isLoading ? skeletonLoader : ";")}
`